import {FlexColumnCentered} from "../../../../components/ui/Content";
import {FormTitle} from "../../../../components/Font";
import {ButtonContainer} from "../../../../components/ui/InputSearch";
import React from "react";
import {GetUser, setChangeDataModal} from "../api/slice";
import {ButtonPrimary} from "../../../../components/ui/Button";
import {OKBig} from "../../../../icon/Icon";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {DataForChange} from "../../../../enum/personalInfo";
import {ChangeDataModalInit} from "../../../../interface/Passport/Account/frontend";
import { setChangeDataForChangeNull, setChangeSuccessFalse } from "../UserInfo/slice";


export const ChangeSuccess = () => {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const {changeDataModal} = useAppSelector(state => state.account)
    const {type} = changeDataModal
    const closeModal = () => {
        dispatch(setChangeDataModal(ChangeDataModalInit))
        dispatch(setChangeSuccessFalse())
        dispatch(setChangeDataForChangeNull())
        dispatch(GetUser())
    }
    return <>
        <FlexColumnCentered style={{width: '100%', marginTop: '10px'}}>
            <OKBig/>
            <FormTitle style={{width: 260, marginTop: 24}}>{
                type === DataForChange.phone
                    ? t('auth.phoneSetSuccessful')
                    : t('auth.emailSetSuccessful')
            }</FormTitle>
        </FlexColumnCentered>
        <ButtonContainer style={{marginTop: '34px'}}>
            <ButtonPrimary
                style={{width: '100%', marginTop: 16}}
                onClick={closeModal}>
                {t('auth.finish')}
            </ButtonPrimary>
        </ButtonContainer>
    </>
}